import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Item from './Item';

class ItemsList extends PureComponent {
  render() {
    const { items, onQuantityChange, handleRemove, isCheckout } = this.props;

    return items.map((item) => (
      <Item
        key={item.id}
        item={item}
        onQuantityChange={onQuantityChange}
        handleRemove={handleRemove}
        isCheckout={isCheckout}
      />
    ));
  }
}

ItemsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      itemNumber: PropTypes.string,
      quantity: PropTypes.number,
    }),
  ),
  onQuantityChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  isCheckout: PropTypes.bool,
};

export default ItemsList;
